/**
 * Example JavaScript singleton module
 */

var Menu = (function($) {

  var x = window.matchMedia("(min-width: 901px)")

  function initMenu() {
    
    let hamburgerIcon = $('.hamburger__icon');
    hamburgerIcon.click(function(){
        $('body').toggleClass('has-nav');
        $(this).toggleClass('hamburger__icon--opened');
    });

    let anchorLink = $('.header-nav__subitem--anchor');
    anchorLink.click(function(){
      $('body').removeClass('has-nav');

    });
  }

  function initMenuHover() {

    var hoverTimeout;
    $('.wpml-ls-current-language').hover(function(){
      clearTimeout(hoverTimeout);
      $(this).children('.sub-menu').show();
      }, function(){
        var $self = $(this);
        hoverTimeout = setTimeout(function() {
        $self.children('.sub-menu').hide();
      }, 400);
        
    });
  

    var hoverTimeoutTwo;
    if (!$("body").hasClass("page-template-template-how-it-works")){
    $('.header-nav__item--inactive').hover(function(){
      clearTimeout(hoverTimeoutTwo);
      $(this).children('.sub-menu').css('display','flex');
      $('.current-menu-item .sub-menu').hide();
      }, function(){
        var $self = $(this);
        hoverTimeoutTwo = setTimeout(function() {
        $self.children('.sub-menu').hide();
        $('.current-menu-item .sub-menu').show();
      }, 400);
        
    });
  }


  }

  function init() {

    initMenu();
    if (x.matches) { 
      initMenuHover();
    } else {
    }
    

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Menu.init);
